import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ReviewFlowDataResult } from "@ServerTypes/workflows/workflows.schema";
import type { ReviewDataResult } from "@ServerTypes/reviews/reviews.schema";

const workflowDataSlice = createSlice({
  name: "workflowData",
  initialState: {} as Partial<ReviewFlowDataResult>,
  reducers: {
    setWorkflowData: (_state: Partial<ReviewFlowDataResult>, action: PayloadAction<Partial<ReviewFlowDataResult>>) =>
      action.payload,
  },
});

const workflowResourceTypeSlice = createSlice({
  name: "workflowResourceType",
  initialState: "RESOURCE_TYPE_FILE",
  reducers: {
    setWorkflowResourceType: (_state: string, action: PayloadAction<string>) => action.payload,
  },
});

const reviewDataSlice = createSlice({
  name: "reviewData",
  initialState: {} as ReviewDataResult,
  reducers: {
    setReviewData: (_state: ReviewDataResult, action: PayloadAction<ReviewDataResult>) => action.payload,
  },
});

export const { setWorkflowData } = workflowDataSlice.actions;
export const { setWorkflowResourceType } = workflowResourceTypeSlice.actions;
export const { setReviewData } = reviewDataSlice.actions;

export const workflowData = workflowDataSlice.reducer;
export const workflowResourceType = workflowResourceTypeSlice.reducer;
export const reviewData = reviewDataSlice.reducer;

export default workflowDataSlice.reducer;
